export default __webpack_public_path__ + "static/media/nft16.0ea77d25.png";